/**
 * Отправка данных событий для аналитики
 *
 * @param {String} googleTypeEvent - тип события для метрики Google
 * @array {Object} googleEventParams - параметры события для метрики Google
 * @param {String} yandexEventMessage - сообщение о событии для метрики Yandex
 * @param {String} logMessage - сообщение в лог о событии
 * @param {Number} delay - время задержки отправки в миллисекундах
 * @constructor
 */
window.AnalyticsManager = function (googleTypeEvent, googleEventParams, yandexEventMessage, logMessage, delay) {

    var delayTime = !delay ? 0 : delay;

    try {

        setTimeout(function () {

            gtag('event', googleTypeEvent, googleEventParams);
            yaCounter47393497.reachGoal(yandexEventMessage);
            log(logMessage);
        }, delay);

    } catch (e) {
        log(e);
    }

    /**
     * Логгирование
     */
    function log(message) {
        try {
            if (window.console) {
                console.log(message);
            }
        } catch (e) {
        }
    }
};
